import Button from '@ui/Button';
import { InputFormField } from '@ui/Form/Fields';
import { Translate, I18n } from 'react-redux-i18n';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import Form from '@ui/Form';
import { registerNew } from '@actions/auth';
import { useRedux } from 'use-redux';
import { getTimeZone } from '@utils/date';
import { ENTITIES } from '@components/gui/register/constants';
import styles from './styles.module.scss';
import { getValidators } from '../validation';
import { yupResolver } from '@hookform/resolvers/yup';

interface Props {
  onSignIn: () => void;
}

const RegisterParent: FC<Props> = ({ onSignIn }) => {
  const [
    {
      auth: { user },
      i18n,
    },
    dispatch,
  ] = useRedux();

  const { parentValidation } = getValidators();
  const formMethods = useForm<FormData>({
    resolver: yupResolver(parentValidation),
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues: {},
  });

  const handleFormSubmit = async (values: FormData) => {
    dispatch(
      registerNew({
        entity: ENTITIES.parent,
        language: i18n.locale,
        timezone: getTimeZone(),
        ...values,
      })
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <span className={styles.stepTitle}>
          {I18n.t('onboarding.regParent.title')}
        </span>
        <p className={styles.stepHint}>{I18n.t('onboarding.regParent.info')}</p>
      </div>
      <div className={styles.right}>
        <Form formMethods={formMethods} onSubmit={handleFormSubmit}>
          <InputFormField
            name="email"
            placeholder={I18n.t('placeholder.email')}
          />
          <InputFormField
            type="password"
            name="password"
            placeholder={I18n.t('placeholder.password')}
          />
          <InputFormField
            name="realName"
            placeholder={I18n.t('placeholder.name')}
          />
          <InputFormField
            name="phone"
            placeholder={I18n.t('placeholder.phone')}
          />

          <p className={styles.agreement}>{I18n.t('onboarding.agreement')}</p>

          <div className={styles.actionsWrapper}>
            <Button type="submit" color="green">
              <Translate value="auth.signup" />
            </Button>
            <Button color="green" onClick={onSignIn}>
              <Translate value="onboarding.hasAccount" />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RegisterParent;
